module.exports = __webpack_public_path__ + "static/img/zhongguorenmin.8b39a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/zhongguorenmin.png
// module id = l5z0
// module chunks = 36